import { render, staticRenderFns } from "./PasswordResetPage.vue?vue&type=template&id=689b5e90&scoped=true&"
import script from "./PasswordResetPage.vue?vue&type=script&lang=js&"
export * from "./PasswordResetPage.vue?vue&type=script&lang=js&"
import style0 from "./PasswordResetPage.vue?vue&type=style&index=0&id=689b5e90&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "689b5e90",
  null
  
)

export default component.exports